import { OPEN_NETWORK_ERROR_MODAL, CLOSE_NETWORK_ERROR_MODAL } from '../actions/actionTypes';

const initialState: {opened: boolean} = {opened: false};

export const networkErrorModalReducer = (state: {opened: boolean} = initialState, action: any) => {
  switch (action.type) {
    case OPEN_NETWORK_ERROR_MODAL:
      return {
        ...state,
        opened: true
      }; 
    case CLOSE_NETWORK_ERROR_MODAL:
      return {
        ...state,
        opened: false
      }; 
    default:
      return state;
  }
};
